import { Component, Input, OnChanges } from '@angular/core';
import { ReportColumn } from '../../shared/data-table/data-table.component';
import { mapBreakdownRows, topItems } from '../../utils/chart-helpers';
import { CHART_COLORS } from '../../utils/chart-theme';
import { breakdownRowName, fmtMiles, fmtMoney, sumField } from '../../utils/kpi-helpers';

interface BreakdownSection {
  titlePrefix: string;
  jobItems: any[];
  revenueItems: any[];
  useDonut: boolean;
  tableRows: any[];
}

const BREAKDOWN_COLUMNS: ReportColumn[] = [
  { key: 'name', header: 'Name' },
  { key: 'totalJobs', header: 'Total Jobs', value: true },
  { key: 'totalCompletedJobs', header: 'Completed', value: true },
  { key: 'totalCancelledJobs', header: 'Cancelled', value: true },
  { key: 'totalCadJobs', header: 'CAD', value: true },
  { key: 'totalMiles', header: 'Miles', value: true, render: (row) => fmtMiles(row.totalMiles) },
  { key: 'totalRevenue', header: 'Revenue', value: true, render: (row) => fmtMoney(row.totalRevenue) }
];

function buildSection(titlePrefix: string, rows: any[], nameField: string): BreakdownSection {
  const jobItems = topItems(mapBreakdownRows(rows, nameField, 'totalJobs'));
  const revenueItems = topItems(mapBreakdownRows(rows, nameField, 'totalRevenue'));
  const tableRows = (rows || []).map((row) => ({ ...row, name: breakdownRowName(row, nameField) }));
  return { titlePrefix, jobItems, revenueItems, useDonut: jobItems.length <= 6, tableRows };
}

@Component({
  selector: 'app-br-breakdown-tab',
  templateUrl: './breakdown-tab.component.html'
})
export class BrBreakdownTabComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() error: string;
  @Input() data: any;

  readonly columns = BREAKDOWN_COLUMNS;
  readonly primaryColor = CHART_COLORS[0];
  moneyFormatter = fmtMoney;

  totalsStats: any[] = [];
  spaceTypeJobsBySpace: any[] = [];
  spaceTypeSection: BreakdownSection;
  losSection: BreakdownSection;
  serviceAreaSection: BreakdownSection;

  ngOnChanges() {
    if (!this.data) return;

    const spaceTypeKpis = this.data.spaceTypeKpis || [];
    const losKpis = this.data.losKpis || [];
    const serviceAreaKpis = this.data.serviceAreaKpis || [];

    this.totalsStats = this.data.totals || [
      { label: 'Total Jobs', value: sumField(spaceTypeKpis, 'totalJobs') },
      { label: 'Completed', value: sumField(spaceTypeKpis, 'totalCompletedJobs') },
      { label: 'Cancelled', value: sumField(spaceTypeKpis, 'totalCancelledJobs') },
      { label: 'CAD', value: sumField(spaceTypeKpis, 'totalCadJobs') },
      { label: 'Total Miles', value: Number(sumField(spaceTypeKpis, 'totalMiles').toFixed(1)) },
      { label: 'Total Revenue ($)', value: sumField(spaceTypeKpis, 'totalRevenue') }
    ];

    this.spaceTypeJobsBySpace = topItems(mapBreakdownRows(spaceTypeKpis, 'spaceType', 'totalJobs'));
    this.spaceTypeSection = buildSection('Space Type', spaceTypeKpis, 'spaceType');
    this.losSection = buildSection('Level of Service', losKpis, 'los');
    this.serviceAreaSection = buildSection('Service Area', serviceAreaKpis, 'serviceArea');
  }
}
